var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { "margin-bottom": "30px" }, attrs: { gutter: 30 } },
    _vm._l(_vm.pair, function(info, j) {
      return _c(
        "el-col",
        {
          key: j,
          staticClass: "card-info-col",
          attrs: { xs: 24, sm: 12, lg: 12 }
        },
        [
          _c("div", { staticClass: "card-style stats load-up" }, [
            _c("div", { staticClass: "left" }, [
              _c("div", [
                info.value
                  ? _c(
                      "div",
                      { staticClass: "value" },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": info.value,
                            duration: 2600,
                            decimals: info.decimal ? info.numberOfDecimal : 0
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "unit" }, [
                          _vm._v(_vm._s(info.unit))
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "label" }, [
                  _vm._v("\n            " + _vm._s(info.label) + "\n          ")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "span",
                { staticStyle: { "font-size": "2.5em", color: "White" } },
                [_c("i", { class: info.icon })]
              )
            ])
          ])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }